import { render, staticRenderFns } from "./block-contacts.vue?vue&type=template&id=c426e876&scoped=true"
import script from "./block-contacts.vue?vue&type=script&lang=js"
export * from "./block-contacts.vue?vue&type=script&lang=js"
import style0 from "./block-contacts.vue?vue&type=style&index=0&id=c426e876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c426e876",
  null
  
)

export default component.exports